function ConditionFormController(stateService, CommonService, toasterService, eventService) {
  const ctrl = this;
  const checkName = CommonService.checkName;

  ctrl.$onInit = () => {
    ctrl.bracketAddMode = 0;
    ctrl.clearError();
    ctrl.startSelected = null;
    ctrl.endSelected = 0;
    if (!ctrl.selection) {
      ctrl.condition = {
        blocks: [],
        statement: '',
        triggers: [],
      };
      ctrl.newCondition = true;
      ctrl.viewMode = false;
    } else {
      ctrl.condition = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
    }
    // Track the number of "open" statement blocks
    ctrl.openBlocks = 0;
    ctrl.newBlock = {
      type: undefined,
      name: undefined,
      relationToPrevious: undefined,
    };
    ctrl.operators = ['and', 'or'];
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    ctrl.loadVariables(ctrl.workspaceId);
    stateService.getTriggers(ctrl.workspaceId).then(data => {
      ctrl.triggers = data;
      ctrl.condition.triggers = fillTriggerTypes(ctrl.condition.triggers);
    });
  };

  ctrl.$onChanges = () => {
    if (!ctrl.selection) {
      ctrl.condition = {
        blocks: [],
        statement: '',
        triggers: [],
      };
      ctrl.newCondition = true;
      ctrl.viewMode = false;
    } 
  }

  ctrl.addBlock = () => {
    if (ctrl.condition.blocks.length > 0) {
      ctrl.newBlock.relationToPrevious = 'and';
    }
    ctrl.condition.blocks.push(angular.copy(ctrl.newBlock));
    ctrl.openBlocks++;
  };

  ctrl.addBracket = () => {
    ++ctrl.bracketAddMode;
  };

  eventService.on('start-bracket-picked', function (event, args) {
    ctrl.startSelected = args;
  });

  eventService.on('end-bracket-picked', function (event, args) {
    ctrl.endSelected = args;
  });

  // Remove condition from the list
  ctrl.removeBlock = event => {
    ctrl.condition.blocks.splice(event.blockIndex, 1);
    ctrl.openBlocks--;
    checkRelations();
    ctrl.compileSentence();
    ctrl.condition = angular.copy(ctrl.condition);
  };

  ctrl.saveBlock = event => {
    // Prevent incorrect default value from overwriting the correct value set in ConditionForm component
    ctrl.condition.blocks[event.blockIndex] = event.newBlock;
    ctrl.openBlocks--;
    ctrl.compileSentence();
    ctrl.condition = angular.copy(ctrl.condition);
  };

  ctrl.blockOpen = event => {
    ctrl.openBlocks++;
  };

  ctrl.checkOpenStates = () => {
    return ctrl.openBlocks > 0;
  };

  ctrl.checkDuplicate = () => {
    ctrl.duplicateName = checkName(ctrl.conditions, ctrl.condition);
  };

  ctrl.toggleEditMode = value => {
    if (value) {
      ctrl.viewMode = false;
    } else {
      ctrl.condition = angular.copy(ctrl.selection);
      ctrl.condition.triggers = fillTriggerTypes(ctrl.condition.triggers);
      ctrl.viewMode = true;
    }
  };

  const checkRelations = () => {
    if (ctrl.condition.blocks.length > 0 && ctrl.condition.blocks[0].relationToPrevious) {
      ctrl.condition.blocks[0].relationToPrevious = undefined;
    }
  };

  ctrl.clearForm = () => {
    ctrl.conditionForm.$setPristine(true);
    ctrl.conditionForm.$setUntouched(true);
    ctrl.viewMode = false;
    ctrl.duplicateName = false;
    ctrl.openBlocks = 0;
    ctrl.condition = {
      blocks: [],
      statement: '',
      name: '',
      description: '',
      triggers: [],
    };
  };

  ctrl.checkValidity = () => {
    return (
      ctrl.openBlocks > 0 || ctrl.duplicateName ||
      (ctrl.condition.blocks && ctrl.condition.blocks.length === 0) ||
      ctrl.condition.triggers.length === 0
    );
  };

  ctrl.clearError = () => {
    ctrl.hasSyntaxError = false;
    ctrl.errorDescription = "";
  }

  ctrl.onSubmit = () => {
    if (ctrl.condition.id !== undefined) {
      // OLD CONDITION EDIT
      const conditionObject = {
        condition: ctrl.condition.condition,
        name: ctrl.condition.name,
        description: ctrl.condition.description,
        triggers: parseTriggers(ctrl.condition.triggers),
      };
      stateService.editCondition(ctrl.workspaceId, ctrl.condition.id, conditionObject).then(
        response => {
          if (response.statusCode === 200) {
            ctrl.clearError();
            toasterService.success('toaster.pis-event', 'toaster.pis-edit-condition-successful');
          } else {
            ctrl.hasSyntaxError = true;
            let parsed = JSON.parse(response.data);
            ctrl.errorDescription = parsed.feedback[0].feedback[0].feedback[0].message;
            toasterService.error('toaster.pis-event', 'toaster.pis-edit-condition-failure');
          }
        },
        err => {
          console.log(err);
        }
      );
    } else {
      // NEW CONDITION
      const conditionObject = {
        condition: ctrl.condition.statement,
        name: ctrl.condition.name,
        description: ctrl.condition.description,
        triggers: handleTriggers(ctrl.condition.triggers),
      };
      stateService.addCondition(conditionObject, ctrl.workspaceId).then(
        response => {
          if (response.statusCode === 200) {
            toasterService.success('toaster.pis-event', 'toaster.pis-new-condition-successful');
          } else {
            toasterService.error('toaster.pis-event', 'toaster.pis-new-condition-failure');
          }
        },
        err => {
          console.log(err);
        }
      );
    }
  };

  const parseTriggers = triggers => {
    let list = [];
    _.each(triggers, trigger => {
      if (trigger && trigger.id >= 0) {
        list.push({ "trigger": { id: trigger.id } });
      } else if (trigger.trigger && trigger.trigger.id === undefined) {
        list.push({ "trigger": { id: trigger.trigger } });
      } else {
        list.push(trigger);
      }
    });
    return list;
  };

  const fillTriggerTypes = triggers => {
    _.each(triggers, trigger => {
      if (trigger.trigger) {
        trigger.description = trigger.trigger.description;
      } else {
        if (trigger.skip_trigger_all) {
          trigger.type = 'Skip: All Stream Collections';
        } else if (trigger.skip_trigger_id >= 0) {
          trigger.type = 'Skip: Stream Collection';
          trigger.target = ctrl.triggers.find(({ id }) => id === trigger.skip_trigger_id).name;
        } else if (trigger.disable_trigger_id >= 0) {
          trigger.type = 'Disable: Stream Collection';
          trigger.target = ctrl.triggers.find(({ id }) => id === trigger.disable_trigger_id).name;
        } else if (trigger.disable_trigger_all) {
          trigger.type = 'Disable: All Stream Collections';
        } else if (trigger.skip_condition_id >= 0) {
          trigger.type = 'Skip: Condition';
          trigger.target = ctrl.conditions.find(({ id }) => id === trigger.skip_condition_id).name;
        } else if (trigger.disable_condition_id >= 0) {
          trigger.type = 'Disable: Condition';
          trigger.target = ctrl.conditions.find(({ id }) => id === trigger.disable_condition_id).name;
        } else if (trigger.initialize_condition_id >= 0) {
          trigger.type = 'Init: Condition';
          trigger.target = ctrl.conditions.find(({ id }) => id === trigger.initialize_condition_id).name;
        } else if (trigger.initialize_condition_all) {
          trigger.type = 'Init: All Conditions';
        } else if (trigger.set) {
          trigger.type = 'Set variable';
        } else if (trigger.wait_condition) {
          trigger.type = 'Wait';
        }
      }
    });
    return triggers;
  };

  const handleTriggers = triggers => {
    let list = [];
    _.each(triggers, trigger => {
      if (trigger.id || trigger.id === 0) {
        list.push({ trigger: { id: trigger.id } });
      } else if (trigger.trigger && !trigger.type) {
        list.push({ trigger: { id: trigger.trigger.id } });
        // Skip trigger
      } else if (trigger.skip_trigger_id >= 0 || trigger.skip_trigger_all) {
        if (trigger.skip_trigger_id >= 0) {
          list.push({ skip_trigger_id: trigger.skip_trigger_id, name: trigger.name });
        } else if (trigger.skip_trigger_all) {
          list.push({ skip_trigger_all: trigger.skip_trigger_all, name: trigger.name });
        }
        // Disable trigger
      } else if (trigger.disable_trigger_id >= 0 || trigger.disable_trigger_all) {
        if (trigger.disable_trigger_id >= 0) {
          list.push({ disable_trigger_id: trigger.disable_trigger_id, name: trigger.name });
        } else if (trigger.disable_trigger_all) {
          list.push({ disable_trigger_all: trigger.disable_trigger_all, name: trigger.name });
        }
        // Skip condition
      } else if (trigger.skip_condition_id >= 0) {
        list.push({ skip_condition_id: trigger.skip_condition_id, name: trigger.name });
        // Disable condition
      } else if (trigger.disable_condition_id >= 0) {
        list.push({ disable_condition_id: trigger.disable_condition_id, name: trigger.name });
        // Initialize condition
      } else if (trigger.initialize_condition_id >= 0 || trigger.initialize_condition_all) {
        if (trigger.initialize_condition_id >= 0) {
          list.push({ initialize_condition_id: trigger.initialize_condition_id, name: trigger.name });
        } else {
          list.push({ initialize_condition_all: trigger.initialize_condition_all, name: trigger.name });
        }
        // Set
      } else if (trigger.set) {
        list.push({ set: trigger.set, name: trigger.name });
        // Wait/Delay
      } else if (trigger.wait_condition) {
        list.push({ wait_condition: trigger.wait_condition, name: trigger.name, delay: trigger.delay });
      }
    });
    return list;
  };

  ctrl.onSelectTriggers = event => {
    ctrl.condition.triggers = fillTriggerTypes(event.selectedTriggers);
    ctrl.condition = angular.copy(ctrl.condition);
  };

  ctrl.compileSentence = () => {
    ctrl.condition.statement = '';
    ctrl.selectedBrackets = [];
    _.each(ctrl.condition.blocks, block => {
      if (block.notOperation) {
        ctrl.condition.statement += 'NOT ';
      }
      if (block.relationToPrevious) {
        ctrl.condition.statement += ' ' + block.relationToPrevious.toUpperCase() + ' ';
      }
      if (block.startBrackets.length > 0) {
        _.each(block.startBrackets, bracket => {
          ctrl.condition.statement += '(';
        });
      }
      if (block.type === 0) {
        // ENVIRONMENT VARIABLE
        ctrl.condition.statement += `#${block.name}`;
        if (block.operator && block.value) {
          ctrl.condition.statement += block.operator.value + block.value;
        }
      } else if (block.type === 1) {
        // MACRO VARIABLE
        // @ at front
        ctrl.condition.statement += `@${block.name}.${block.subName}`;
        if (block.operator && block.value) {
          ctrl.condition.statement += block.operator.value + block.value;
        }
      } else if (block.type === 2) {
        // TRUTH VALUE
        ctrl.condition.statement += block.name;
      } else if (block.type === 3) {
        // DATE/TIME
        if (block.name === 'WEEKEND' || block.name === 'WEEKDAY') {
          ctrl.condition.statement += `${block.name}()`;
        } else if (block.name === 'DATE') {
          let convertedDates = block.dates.map(d => `'${DateTime.fromJSDate(d).toFormat('dd.MM.yyyy')}'`);
          ctrl.condition.statement += `${block.name}(${constructDates(convertedDates)})`;
        } else if (block.name === 'DATE_BETWEEN') {
          let convertedDates = block.dates.map(d => {
            return [`'${DateTime.fromJSDate(d.start).toFormat('dd.MM.yyyy')}'`, `'${DateTime.fromJSDate(d.end).toFormat('dd.MM.yyyy')}'`];
          });
          ctrl.condition.statement += `${block.name}(${constructDates(convertedDates)})`;
        } else if (block.name === 'DAY_OF_WEEK') {
          let convertedDates = block.weekdays.map(d => {
            return [`'${d}'`];
          });
          ctrl.condition.statement += `${block.name}(${constructDates(convertedDates)})`;
        } else if (block.name === 'MINUTE') {
          let convertedDates = block.minutes.map(d => {
            return [`'${d}'`];
          });
          ctrl.condition.statement += `${block.name}(${constructDates(convertedDates)})`;
        } else if (block.name === 'MINUTE_BETWEEN') {
          let convertedDates = block.minutesBetween.map(d => {
            return [`'${d.start}','${d.end}'`];
          });
          ctrl.condition.statement += `${block.name}(${constructDates(convertedDates)})`;
        } else if (block.name === 'TIME_BETWEEN') {
          let convertedDates = block.dates.map(d => {
            return [`'${DateTime.fromJSDate(d.start).toFormat('HH:mm')}'`, `'${DateTime.fromJSDate(d.end).toFormat('HH:mm')}'`];
          });
          ctrl.condition.statement += `${block.name}(${constructDates(convertedDates)})`;
        } else if (block.name === 'DATE_TIME_BETWEEN') {
          let convertedDates = block.dates.map(d => {
            return [
              `'${DateTime.fromJSDate(d.startDate).toFormat('dd.MM.yyyy')} ${DateTime.fromJSDate(d.startTime).toFormat('HH:mm')}'`,
              `'${DateTime.fromJSDate(d.endDate).toFormat('dd.MM.yyyy')} ${DateTime.fromJSDate(d.endTime).toFormat('HH:mm')}'`,
            ];
          });
          ctrl.condition.statement += `${block.name}(${constructDates(convertedDates)})`;
        } else if (block.name === 'YEAR') {
          let convertedDates = block.years.map(d => `'${DateTime.fromJSDate(d).toFormat('yyyy')}'`);
          ctrl.condition.statement += `${block.name}(${constructDates(convertedDates)})`;
        }
      }
      if (block.endBrackets.length > 0) {
        _.each(block.endBrackets, bracket => {
          ctrl.condition.statement += ')';
        });
      }
    });
  };

  const constructDates = dates => dates.join();

  ctrl.loadVariables = id => {
    stateService.getWorkspaceVariables(id).then(variables => {
      ctrl.environmentVariableObjects = _.filter(variables, function(variable) {
        return variable.type === 'user';
      });
  
      let userEnvVarStrings = [];
      _.each(ctrl.environmentVariableObjects, function (item) {
        userEnvVarStrings.push(item.name);
      });

      stateService.getVariables(id).then(data => {
        ctrl.variables = data;
        ctrl.variables.environment_variables = userEnvVarStrings;
      });
    });
  };
}

angular
  .module('pis-tool.module')
  .controller('ConditionFormController', ConditionFormController);
